import { render, staticRenderFns } from "./AffirmsortAlphabetical.vue?vue&type=template&id=739d04b8&"
import script from "./AffirmsortAlphabetical.vue?vue&type=script&lang=js&"
export * from "./AffirmsortAlphabetical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports